import { Component, inject, input, InputSignal } from '@angular/core';
import { ListInvoice } from '../types/ListInvoice';
import {
    DayjsModule,
    DisplayCurrencyModule,
    HighlightModule,
    StringPreviewModule,
    SupplierDisplayNamePipe,
} from '@lib/util';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IimCardModule } from '@iim-angular/components';
import { UnitModule } from '@lib/unit';
import { CopyToClipboardModule, DebugModule, View } from '@lib/core';
import {
    DocumentItemAttributeComponent,
    DocumentItemComponent,
    DocumentItemDescriptionComponent,
    DocumentItemLabelComponent,
    DocumentItemNameComponent,
    DocumentItemPositionIndicatorComponent,
    DocumentItemPriceComponent,
    DocumentItemValueComponent,
} from '@lib/document';
import { Router } from '@angular/router';
import { IInvoiceItemOrderRelationViewDto } from '../../detail/types/IStandaloneInvoiceDetail';

@Component({
    selector: 'invoice-list-preview',
    templateUrl: './invoice-list-preview.component.html',
    imports: [
        SupplierDisplayNamePipe,
        CommonModule,
        TranslateModule,
        HighlightModule,
        IimCardModule,
        StringPreviewModule,
        UnitModule,
        CopyToClipboardModule,
        DayjsModule,
        DisplayCurrencyModule,
        DebugModule,
        DocumentItemComponent,
        DocumentItemPositionIndicatorComponent,
        DocumentItemNameComponent,
        DocumentItemDescriptionComponent,
        DocumentItemAttributeComponent,
        DocumentItemLabelComponent,
        DocumentItemValueComponent,
        DocumentItemPriceComponent,
    ],
    styleUrl: './invoice-list-preview.component.scss',
})
export class InvoiceListPreviewComponent {
    readonly invoice: InputSignal<ListInvoice> = input.required();
    readonly searchQuery: InputSignal<string> = input('');

    private readonly _router = inject(Router);

    navigateToReceipt(receiptId: number, receiptNumber: string) {
        this._router.navigate([View.CLIENT, 'order', 'receipt', receiptId], {
            queryParams: { receiptNumber: receiptNumber },
        });
    }

    navigateToOrder(relatedOrder: IInvoiceItemOrderRelationViewDto) {
        this._router.navigate([View.CLIENT, 'order', relatedOrder.orderId, 'detail']);
    }
}
